export const DEFAULT_START_INDEX = 0;
